module.exports = __webpack_public_path__ + "static/media/riyad-bank-logo.6692b49a.png";